import React from "react";
import { CategoryPageMainViewTemplate } from "themes/application/categories/components";

function CategoryPageMainView(props) {
    return <CategoryPageMainViewTemplate {...props} />;
}

export default CategoryPageMainView;
